export default "__VITE_ASSET__Cu6yk1vV__"